import React from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import Herosection from '../Pages/Herosection'
import Homefeatures from '../Pages/Homefeatures'
import Homecount from '../Pages/Homecount/index.js'
import Homeaboutus from '../Pages/Homeaboutus/index.js'
import Homeourpartners from '../Pages/Homeourpartners/index.js'
import Homepricing from '../Pages/Homepricing/index.js'
import Homehrmanagements from '../Pages/Homehrmanagements/index.js'
import Homepayroll from '../Pages/Homepayroll/index.js'
import Homeattendence from '../Pages/Homeattendence/index.js'
import Hometestinomials from '../Pages/Hometestinomials/index.js'
import Homeperformence from '../Pages/Homeperformence/index.js'
import Homehrhelpdesk from '../Pages/Homehrhelpdesk/index.js'
import Homerecruitment from '../Pages/Homerecruitment/index.js'


const Home = () => {
  return (
    <div>
      <Header />
      <Herosection />
      <Homecount />
      <Homefeatures />
      <Homeaboutus />
      <Homeourpartners />
      <Homepricing />
      <Homehrmanagements />
      <Homepayroll />
      <Homeattendence/>
      <Hometestinomials/>
      <Homeperformence/>
      <Homehrhelpdesk/>
      <Homerecruitment/>

      <Footer />
    </div>
  )
}

export default Home
